'use es6';

import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { getPropertyGroupsByObjectType, createGetPropertyGroupsByObjectType } from 'reference-resolvers/api/PropertiesAPI';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
export const createPropertyGroupReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.PROPERTY_GROUPS,
  createFetchByIds: opts => createGetPropertyGroupsByObjectType(opts)(),
  fetchByIds: getPropertyGroupsByObjectType
}, options));
export default createPropertyGroupReferenceResolver();